module.exports = __webpack_public_path__ + "img/about3.667507c5.jpg";